import { css } from 'aphrodite';
import * as React from 'react';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { ClockAlertIcon } from '../../../../web/components/svgs/icons/ClockAlertIcon';
import { FollowUpsIcon } from '../../../../web/components/svgs/icons/FollowUpsIcon';
import { PepperIcon } from '../../../components/svgs/icons/PepperIcon';
import { ILeadFollowUp } from '../../../viewModels/queue';
import { formatFollowUpDate, pepperColor } from '../followUps';
import { styleSheet } from './styles';

interface IProps {
	followUp?: ILeadFollowUp;
	layout?: 'stacked' | 'inline';
}

export const FollowUpDue: React.FC<IProps> = ({ followUp, layout = 'stacked' }) => {
	const spiceLabel = `${followUp?.importance ?? 'Low'} spice level`;
	return (
		<div className={css(layout === 'stacked' ? styleSheet.dueStacked : styleSheet.dueInline)}>
			<span className={css(styleSheet.dueDate)}>{formatFollowUpDate(followUp)}</span>
			<span className={css(styleSheet.dueIcons)}>
				<FollowUpsIcon className={css(styleSheet.icon18)} fill={THEME.colors.icon.gray} />
				{followUp?.scheduled ? (
					<>
						<span className={css(styleSheet.iconWrap)} role='img' aria-label='Scheduled' title='Scheduled'>
							<ClockAlertIcon className={css(styleSheet.icon16)} fillColor={THEME.colors.icon.primary} />
						</span>
						<span className={css(styleSheet.iconWrap)} role='img' aria-label={spiceLabel} title={spiceLabel}>
							<PepperIcon className={css(styleSheet.icon16)} fillColor={pepperColor(followUp.importance)} />
						</span>
					</>
				) : null}
			</span>
		</div>
	);
};
